import type { SelfServicePlanState } from "@/shared/apiTypes";

export const defaultSelfServicePlan: SelfServicePlanState = {
  tier: "free",
  selected_tier: "free",
  selectedTier: "free",
  effective_tier: "free",
  effectiveTier: "free",
  paid_tier: null,
  paidTier: null,
  name: "Free",
  price_label: "$0",
  priceLabel: "$0",
  billing_unit: "account",
  billingUnit: "account",
  summary: "Starter workspace with core views and light usage.",
  quota_profile: { workspaces: 1, tasks: 100, docs: 5, reports: 3 },
  quotaProfile: { workspaces: 1, tasks: 100, docs: 5, reports: 3 },
  planned_capabilities: ["Core workspace views"],
  plannedCapabilities: ["Core workspace views"],
  status: "shadow",
  billing_status: "shadow",
  billingStatus: "shadow",
  entitlement_status: "shadow",
  entitlementStatus: "shadow",
  billing_mode: "shadow",
  billingMode: "shadow",
  is_shadow: true,
  isShadow: true,
  checkout_ready: false,
  checkoutReady: false,
  billing_portal_ready: false,
  billingPortalReady: false,
  entitlements_active: false,
  entitlementsActive: false,
  organization_admin_available: false,
  organizationAdminAvailable: false,
  enterprise_contact_sales: true,
  enterpriseContactSales: true,
};
